export default __webpack_public_path__ + "static/media/viguetas-detalle.a05f9f83.png";